<template>
  <div class="load-hide">
    <div class="recharge_types card_online">
      <div>
        <mt-datetime-picker
          ref="picker"
          type="date"
          :startDate="startDate"
          :endDate ="endDate"
          v-model="pickerValue">
        </mt-datetime-picker>
      </div>
      <div class="co_in">
        <div class="before_title">请填写您的手机号码</div>
        <div class="after_context">
          <div class="more_num">+86</div>
          <input type="text" v-model="phoneNumber" class="phone_ipt" placeholder="请填写手机号码">
        </div>
        <div class="before_title">请点击"获取验证码"按钮，填写您收到的验证码</div>
        <div class="after_context ac_message">
          <div class="more_message">验证码</div>
          <input type="text" v-model="msg">
          <input v-if="!sendMsgDisabled" @click="getMessage" class="getMessage" type="button" value="获取验证码">
          <input v-if="sendMsgDisabled" class="getMessage" type="button" :value="time+'s'">
        </div>
        <div class="before_title">请选择您的性别(选填)</div>
        <div class="after_context ac_gender">
          <div class="more_gender">性别</div>
          <div @click="goGender" class="more_img">
            <span class="finallGender">{{getCG[isWhatGender]}}</span>
            <img width="8px" height="12.5px" src="../../../assets/img/icon_right.png">
          </div>
        </div>
        <div class="before_title">请选择您的生日(选填)</div>
        <div class="after_context ac_message">
          <div  class="more_date">年/月/日</div>
          <!--<input @click="openPicker" v-model="pickerValue" type="text" class="dpss">-->
          <div v-if="pickerValue.length>0" @click="openPicker" class="dpss">{{pickerValue | date('%Y-%m-%d')}}</div>
          <div v-else @click="openPicker" class="dpss"></div>
        </div>
      </div>
      <div class="co_input">
        <div><input @click="confirm" class="co_card" type="button" value="办理"></div>
      </div>
      <div v-if="isGender == true" class="overUp">
        <div class="black"></div>
        <div class="white_div">
          <div class="co_tip">请选择性别</div>
          <div class="ch_one"><input :class="{green_border:isWhatGender=='N'}" @click="ch_none" value="保密" type="button"></div>
          <div class="ch_one"><input :class="{green_border:isWhatGender=='M'}" @click="ch_b" value="男" type="button"></div>
          <div class="ch_one"><input :class="{green_border:isWhatGender=='G'}" @click="ch_g" value="女" type="button"></div>
          <!--<div class="g_b_button"><input @click="backGender" type="button" value="确定"></div>-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import auth from '../../../lib/auth';
import constants from '../../../lib/constants';

export default {
  data(){
      return{
        phoneNumber:'',
        msg:'',
        cust_birthday:'',
        time: 60, // 发送验证码倒计时
        sendMsgDisabled: false,
        isGender:false,
        isWhatGender:'',
        getCG: {
          "N":"保密",
          "M": "男",
          "G": "女"
        },
        pickerValue:'',
        startDate:new Date("1970-01-01"),
        endDate:new Date()
      }
  },
  mounted(){

  },
  methods: {
    openPicker() {
      this.$refs.picker.open();
    },
    send() {
      let me = this;
      me.sendMsgDisabled = true;
      let interval = window.setInterval(function() {
        if ((me.time--) <= 0) {
          me.time = 60;
          me.sendMsgDisabled = false;
          window.clearInterval(interval);
        }
      }, 1000);
    },
    goGender(){
        this.isGender = true;
    },
    ch_none(){
        this.isWhatGender = 'N'
        this.isGender = false;
    },
    ch_b(){
      this.isWhatGender = 'M'
      this.isGender = false;
    },
    ch_g(){
      this.isWhatGender = 'G'
      this.isGender = false;
    },
    getMessage(){
      console.log(this.phoneNumber,111);
      var numREG = /^(((13[0-9]{1})|(14[0-9]{1})|(15[0-9]{1})|(16[0-9]{1})|(17[0-9]{1})|(18[0-9]{1})|(19[0-9]{1}))+\d{8})$/;
      if(!numREG.test(this.phoneNumber)){
        this.$alert("请输入正确的手机号!")
      }else{
        this.$http.post(constants.API_HOST + constants.API_CARD_APPLY_SMS, {
          cust_mobile:this.phoneNumber,
          card_type:'fcard'
        }).then((result) => {
          let data = result.data;
          if (data.code === "200") {
            console.log(data.data);
            this.send();
          }else {
            this.$alert(data.data);
          }
        }, (error) => {
          error.data && this.$alert(error.data);
        });
      }
    },
    confirm(){
      var dps = this.pickerValue;
      this.cust_birthday = new Date(dps).getTime();
      console.log(this.cust_birthday,222);
      if(!this.phoneNumber || !this.msg){
        this.$alert("请输入正确信息")
      }else{
        this.$http.post(constants.API_HOST + constants.API_CARD_APPLY, {
          cust_mobile:this.phoneNumber,
          card_type:'fcard',
          apply_vcode:this.msg,
          cust_gender:this.isWhatGender,
          cust_birthday:this.cust_birthday
        }).then((result) => {
          let data = result.data;
          if (data.code === "200") {
            console.log(data.data);
            router.push("main");
          }else {
            this.$alert(data.data);
          }
        }, (error) => {
          error.data && this.$alert(error.data);
        });
      }

    },
  }

}

</script>

<style>
  body,html{
    height:100%;
  }
  html {
    font-size:90px!important
  }
  @media only screen and (min-width:319px) {
    html {
      font-size:100px!important
    }
  }@media only screen and (min-width:370px) {
    html {
      font-size:117px!important
    }
  }@media only screen and (min-width:414px) {
    html {
      font-size:129px!important
    }
  }
  @media only screen and (min-width:639px) {
    html {
      font-size:200px!important
    }
  }
  .include-text p{
    margin: 0.1rem 0;
    font-size: 0.13rem;
  }
  .include-text div{
    margin-top: 0.2rem;
  }
  .include-text img{
    width: 200px;
  }

  .include-text input{
    border: 0px;
    background: #3d9946;
    color: #FFF;
    width: 0.875rem;
    height: 0.235rem;
    border-radius: 0.01rem;
  }
  .relieve input{
    width: 0.495rem;
    height: 0.21rem;
    line-height: 0.1rem;
    border: 0px;
    background: #50a200;
    color: #fff;
    border-radius: 0.1rem;
  }
  .recharge-recode input{
    width: 0.63rem;
    height: 0.2rem;
    line-height: 0.1rem;
    border: 0px;
    background: #fff;
    color: #727272;
    border-radius: 0.1rem;
    text-align: center;
  }
  .recharge_types.card_online{
    background: #eff3f6;
  }
  .co_input{
    padding: 0 0.15rem;
    position: fixed;
    bottom:3%;
    left: 0;
    width:100%;
  }
  .co_input input {
    width: 100%;
    height: 0.315rem;
    border: 0;
    border-radius: 0.05rem;
    margin: 0.14rem 0 0;
    font-size: 0.14rem;
  }
  .co_input .co_card{
    background: #3d9946;
    color: #fff;
  }
  .before_title{
    padding:0.16rem 0.15rem;
    color:#888888;
    font-size:0.13rem;
  }
  .after_context{
    height:0.43rem;
    border-top:1px solid #e5e5e5;
    border-bottom: 1px solid #e5e5e5;
    background-color: #fff;
    display: flex;
  }
  .after_context.ac_gender,.after_context.ac_message{
    justify-content: space-between;
  }
  .more_num{
    border: 0;
    border-right: 1px solid #e5e5e5;
    width: 25%;
    font-size: 0.15rem;
    color: #000;
    padding: 0.1rem;
  }
  .after_context input{
    height:100%;
    border: 0;
    outline: none;
  }
  .phone_ipt{
    width:80%;
    padding-left: 0.15rem;
    font-size: 0.14rem;
  }
  .after_context .getMessage{
    width:0.8rem;
    height: 70%;
    border: 1px solid #1aad19;
    color: #1aad19;
    background: #fff;
    margin-top: 1.8%;
    margin-right: 3%;
    text-align: center;
  }
  .more_message{
    border: 0;
    width: 25%;
    font-size: 0.14rem;
    color: #000;
    padding: 0.1rem;
  }
  .more_img{
    line-height: 0.4rem;
    margin-right: 5%;
  }
  .more_gender{
    border: 0;
    width: 25%;
    font-size: 0.15rem;
    color: #000;
    padding: 0.1rem;
  }
  .finallGender{
    font-size:0.14rem;
    margin-right: 5px;
  }
  .more_date{
    border: 0;
    width: 40%;
    font-size: 0.14rem;
    color: #000;
    padding: 0.1rem;
  }
  .overUp{
    width:100%;
    height:100%;
    position: absolute;
    top:0;
    left:0;
    z-index: 999;
    background: #eff3f6;
    padding-top: 0.18rem;
  }
  .white_div{
    position: absolute;
    z-index: 999;
    width: 80%;
    left: 10%;
    top:20%;
  }
  .ch_one{
    width: 100%;
    background: #fff;
    padding-left: 0.15rem;
  }
  .ch_one:last-child{
    padding-bottom: 0.2rem;
  }
  .ch_one input{
    color: #449a4f;
    width: 90%;
    height: 0.45rem;
    font-size: 0.14rem;
    background: #f8f8f8;
    text-align: center;
    outline: none;
    border: 1px solid #e8e8e8;
    margin: 8px;
  }
  .co_tip{
    text-align: center;
    font-size: 0.15rem;
    color: #000;
    padding-top: 0.2rem;
    width: 100%;
    background: #fff;
  }
  .g_b_button input{
    background: #3d9946;
    color: #fff;
    width: 100%;
    height: 0.315rem;
    border: 0;
    border-radius: 0.05rem;
    font-size: 0.14rem;
  }
  .g_b_button{
    position: absolute;
    bottom:3%;
    left:0;
    width:100%;
    padding: 0 0.15rem;
  }
  .just_yes{
    background-image: url(../../../assets/img/yess.png);
    background-size: cover;
    width:0.13rem;
    height:0.095rem;
    background-repeat: no-repeat;
    margin-top: 0.18rem;
  }
  .after_context .dpss{
    white-space: nowrap;
    width:45%;
    padding: 0.1rem;
    font-size:0.14rem;
  }
  .black{
    position: absolute;
    top: 0;
    left: 0;
    background: #000;
    opacity: 0.8;
    width: 100%;
    height: 100%;
  }
  .ch_one .green_border{
    border:1px solid #47994d;
  }
</style>



// WEBPACK FOOTER //
// card_online.vue?6ef7c5ef